import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Layout } from './components/layout/Layout'
import { HomePage } from './pages/HomePage'
import { SolutionsPage } from './pages/SolutionsPage'
import { ProductsPage } from './pages/ProductsPage'
import { AnnouncementPage } from './pages/AnnouncementPage'
import { AnnouncementDetailPage } from './pages/AnnouncementDetailPage'
import { DocsPage } from './pages/DocsPage'
import { AboutPage } from './pages/AboutPage'
import { CooperationPage } from './pages/CooperationPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { ServerErrorPage } from './pages/ServerErrorPage'
import { ForbiddenPage } from './pages/ForbiddenPage'
import { ServiceUnavailablePage } from './pages/ServiceUnavailablePage'
import './styles/globals.scss'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/announcement" element={<AnnouncementPage />} />
          <Route path="/announcement/:id" element={<AnnouncementDetailPage />} />
          <Route path="/docs" element={<DocsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/cooperation" element={<CooperationPage />} />
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="/500" element={<ServerErrorPage />} />
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="/503" element={<ServiceUnavailablePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  </React.StrictMode>,
)
